import React, { useContext, useEffect } from 'react'
import { multiCourse } from '@BUP/constants'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import BupSpinner from '@BUP/components/Loading/Spinner'
import ErrorMessage from '@BUP/components/Error/Message'
import PageLayout from '@BUP/components/Layout/Page'
import ResultsDashboardComponentsMultiCourses from '@BUP/components/SociogramDashboard/ResultsDashboardComponentsMultiCourses'
import ResultsDashboardComponentsUniCourse from '@BUP/components/SociogramDashboard/ResultsDashboardComponentsUniCourse'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'
import { useGetPreAnalyticData } from '@BUP/hooks/Sociogram/preAnalyticData/useGetPreAnalyticData'

const SociogramResultsDashboardPage = () => {
  // TODO: que hacer cuando preAnalyticData viene vacio
  const { type } = useContext(OrganizationContext)

  const history = useHistory()
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.dashBoardSociogram'
  })
  const { result, survey } = useLocation()
  const surveyId = survey && survey.id

  const { loadingPreAnalyticData, preAnalyticData, errorPreAnalyticData } =
    useGetPreAnalyticData(surveyId)

  useEffect(() => {
    if (!survey || !result) {
      history.goBack()
    }
  }, [survey, result, history])

  const courses = survey && survey.courses
  if (!preAnalyticData || loadingPreAnalyticData) {
    return (
      <BupSpinner
        size='large'
        tip={t('spinnerText')}
      />
    )
  }

  if (errorPreAnalyticData) {
    return <ErrorMessage />
  }

  if (type === multiCourse) {
    return (
      <PageLayout>
        <ResultsDashboardComponentsMultiCourses
          results={result}
          preAnalyticData={preAnalyticData}
          courses={courses}
        />
      </PageLayout>
    )
  }
  return (
    <PageLayout>
      <ResultsDashboardComponentsUniCourse
        results={result}
        preAnalyticData={preAnalyticData}
        courses={courses}
      />
    </PageLayout>
  )
}

export default SociogramResultsDashboardPage
